export { default } from './useUnmountEffect';

export type * from './types';
